import React from "react";
import { Switch, Typography, Box } from "@mui/material";
import { generateGuid } from 'helpers';
import { useTranslation } from 'react-i18next';
import { Controller } from "react-hook-form";
import { TooltipCustom } from 'components/common';


export default function FormInputSwitch (props) {
  const {
    position='vertical',
    name,
    control,
    label,
    disabled=false,
    size='medium',
    defaultValue='',
    className,
    helperText
  } = props;

  const [t, i18n] = useTranslation();
  const defaultId = !props?.id && `textfield-${generateGuid()}`;

  return (
    <Box sx={{
      display: 'flex',
      gap: 0.5,
      flexDirection: position === 'vertical' ? 'column' : 'row',
      alignItems: position === 'vertical' ? 'flex-start' : 'center'
    }}>
      <Box sx={{ display: 'flex', flexDirection: 'row', gap: 1, alignItems: 'center' }}>
        <Typography
          variant="subtitle1"
          id={`label-title-${defaultId}`}
        >
          { i18n.exists(label) ? t(label) : label }
        </Typography>
        { helperText && <TooltipCustom title={helperText}/> }
      </Box>
      <Controller
        id={defaultId}
        name={name ?? defaultId}
        control={control}
        defaultValue={defaultValue}
        render={({ field: { onChange, value } }) => (
          <Switch
            size={size ? size : 'medium'}
            onChange={onChange}
            value={value}
            checked={value}
            disabled={disabled}
            className={className}
          />
        )}
      />
    </Box>
  );
};
